// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { AppModule } from './app/app.module';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular';

registerLocaleData(en);

// console.log('ENVIRONMENT: ', environment);

if (environment.production) {
  enableProdMode();
}

// Only initialize Sentry if a DSN is provided (avoids leaking local noise when DSN is blank)
if (environment.sentryDsn) {
  // Prefer a build-time env (VITE_SENTRY_RELEASE), then meta tag, then window global
  const runtimeRelease = ((): string | undefined => {
    try {
      const viteEnv: any = (import.meta as any)?.env;
      if (
        viteEnv &&
        typeof viteEnv.VITE_SENTRY_RELEASE === 'string' &&
        viteEnv.VITE_SENTRY_RELEASE
      ) {
        return viteEnv.VITE_SENTRY_RELEASE as string;
      }
      const meta = document?.querySelector(
        'meta[name="sentry-release"]'
      ) as HTMLMetaElement | null;
      if (meta?.content) return meta.content;
      const w = window as any;
      if (w && typeof w.__SENTRY_RELEASE__ === 'string')
        return w.__SENTRY_RELEASE__;
    } catch {}
    return undefined;
  })();

  Sentry.init({
    dsn: environment.sentryDsn,
    environment:
      environment.environmentName ||
      (environment.production ? 'production' : 'development'),
    release: runtimeRelease || `paykaduna-frontend@${environment.appVersion}`,
    sendDefaultPii: true,
    beforeSend(event) {
      // Allow overriding localhost suppression via environment flag

      if (
        environment.suppressLocalSentry &&
        window &&
        window.location &&
        /localhost|127\.0\.0\.1/.test(window.location.hostname)
      ) {
        return null;
      }
      return event;
    },
    integrations: [
      // You can add browser tracing / replay later if desired
    ],
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.log('Client side bootstrapping error occurred :>> ', err);
  console.error(err);
});
